export const topBarHeight = 64

export const sidebarWidth = 256
